
import apiWorker from '../apiWorker'

const payment_logs =  {
    search : (data) => apiWorker('post',`/v1/admin/payment_logs/search`, data),
}

export default payment_logs;